export const CookiesKeys = {
  consent_disagree: 'consent_disagree',
  sessionAffid: 'sessionAffid',
  landingsParams: 'get_params_landings',
}
